module.exports = __webpack_public_path__ + "img/stone-head-butterfly-pea-wheat.e7f82b50.png";